import styled from '@emotion/styled'
import { parseToRgb, rgba } from 'polished'

import { breakpoints, Small, spacing, Strong, Text, typography } from 'main/ui'

export const MainContainer = styled.div`
  display: flex;
  flex-direction: row;
  margin: ${spacing.majorScale(4)}px 0;
`

export const IconContainer = styled.div`
  margin-right: ${spacing.majorScale(2)}px;
`

export const TableContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;

  @media (min-width: ${breakpoints.lg}px) {
    margin-right: ${spacing.majorScale(4)}px;
  }
`

function tableRowBorderStyle(color: string) {
  const rgbColor = parseToRgb(color)
  const borderColor = rgba({ ...rgbColor, alpha: 0.5 })

  return `1px solid ${borderColor}`
}

export const TableRowContainer = styled.div<{ borderColor: string }>`
  border-bottom: ${({ borderColor }) => tableRowBorderStyle(borderColor)};
  display: flex;
  flex-direction: row;
  padding: ${spacing.minorScale(1)}px;

  :first-child {
    border-top: ${({ borderColor }) => tableRowBorderStyle(borderColor)};
  }
`

export const Synopsis = styled(Small)`
  font-weight: ${typography.fontWeight.bold};
  margin-top: ${spacing.majorScale(3)}px;
`

export const WhenText = styled(Strong)`
  flex: 1;
  margin-right: ${spacing.majorScale(4)}px;
`

export const BodyText = styled(Text)`
  flex: 2;
`
